import React, { useState } from 'react';
import { PageContainer, Button } from '../../../components/common';
import './termsConditions.css';
import { ELEMENT_IDS } from '../../../constants/ids';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';

const TermsConditionNode = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const companyName = COMPANY_CONFIG.name?.toLowerCase();
  const isInterbel =
    companyName === 'interbel' || COMPANY_CONFIG.themeId === 257;
  
  return (
    <div>
       <h2 className="termsConditionNode-Title">
          {isInterbel
            ? 'Acceptable Use Policy'
            : 'Service Terms and Conditions'}
        </h2>
      <div className="termsConditionNode-card">
        <div className="termsConditionNode-iframeContainer">
          <iframe
            id={ELEMENT_IDS.TermsConditionNode}
            src="#"
            title="Terms and Conditions"
            className="termsConditionNode-iframe"
          />
        </div>

        <div className="termsConditionNode-termsOfService">
          <label className="termsConditionNode-checkbox" checked={false}>
            <input id="termsConditionNode-checkbox" type="checkbox" />
            <div className="termsConditionNode-checkboxText">
              <p>By checking this box I agree, I am representing that:</p>
              <ul>
                <li>
                  <span className="termsConditionNode-bullet">•</span> I am at
                  least 18 years old
                </li>
                <li>
                  <span className="termsConditionNode-bullet">•</span> I
                  understand and agree that I will be billed for the services
                  and equipment included in this order. I also acknowledge that
                  all charges will apply as outlined in the agreement.
                </li>
                {/*
                <li>
                  <span id={ELEMENT_IDS.TermsConditionNode} className="termsConditionNode-bullet">•</span> I agree
                  to the{' '}
                  <a href="">Customer Agreement for Residential Services</a>,
                  the <a href="#">Comcast Customer Privacy Notice</a>, the{' '}
                  <a href="#">Paperless Billing Terms of Service</a>, the{' '}
                  <a href="#">Automatic Payment Terms and Conditions</a> and the{' '}
                  <a href="#">Stored Payment Methods Terms and Conditions</a>
                </li>*/}
              </ul>
            </div>
          </label>
        </div>
      </div>
      <div className="termsConditionNode-buttonGroup">
        <Button customId="back" label="Back" variant="secondary" />
        <Button
          customId={ELEMENT_IDS.NEXT_STEP_BUTTON}
          label="I agree & Continue"
          disabled
          right={<span className="termsConditionNode-psnArrow">→</span>}
        />
      </div>
    </div>
  );
};

export default TermsConditionNode;
